<template>
  <div class="bg-surface-default-hi rounded-lg relative p-32">
    <div class="relative z-10">
      <div class="heading-3 mb-8">{{ i18n(translations.deferredPayout) }}</div>
      <div class="body-2 mb-16">
        {{ i18n(translations.deferredPayoutInfoText) }} <br />
        <RevLink :to="DEFERRED_PAYOUT_LINK">
          {{ i18n(translations.deferredPayoutLink) }}
        </RevLink>
      </div>
      <div v-if="hasDefferedPayout" class="relative space-y-16">
        <div
          v-for="(amount, currency) in info"
          :key="currency"
          class="bg-static-default-mid rounded-sm flex p-8"
        >
          <div class="body-1">{{ i18n.currencySymbol(currency) }}</div>
          <div class="body-1-bold flex-1 text-right">
            {{ i18n.price({ amount: amount!, currency }, { symbol: false }) }}
          </div>
        </div>
      </div>
      <div
        v-if="!hasDefferedPayout"
        class="bg-static-default-mid rounded-sm body-1-bold flex p-8"
      >
        {{ i18n(translations.noDeferredPayout) }}
      </div>
    </div>
    <IconLockLocked
      class="text-static-default-low absolute right-16 top-8 z-0 h-[130px] w-[130px] rotate-12 opacity-5"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { GetSellerWallet } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { RevLink } from '@ds/components/Link'
import { IconLockLocked } from '@ds/icons/IconLockLocked'

import { getExternalLinkList } from '~/constants/externalLinks'

import translations from './DeferredPayout.translations'

const props = defineProps<{
  info: GetSellerWallet['deferred_payout']
}>()

const i18n = useI18n()
const currentLocale = useI18nLocale()

const DEFERRED_PAYOUT_LINK = computed(
  () => getExternalLinkList(currentLocale).DEFERRED_PAYOUT_LINKS,
)

const hasDefferedPayout = computed(() => !!Object.keys(props.info).length)
</script>
